module.exports = __webpack_public_path__ + "img/long-arrow-right.d9d08a8b.svg";